
define('text!templates/modules/member/group/lists/group-list-item.html',[],function () { return '<div class="item-section"></div><div class="sub-section box"></div>\n';});

